import { render, staticRenderFns } from "./TemperaturasPantalla.vue?vue&type=template&id=04e1051e&scoped=true"
import script from "./TemperaturasPantalla.vue?vue&type=script&lang=js"
export * from "./TemperaturasPantalla.vue?vue&type=script&lang=js"
import style0 from "./TemperaturasPantalla.vue?vue&type=style&index=0&id=04e1051e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1051e",
  null
  
)

export default component.exports